export { AmenitiesList } from "./amenities-list";
